const LOW_PRIORITY = 0
const MEDIUM_PRIORITY = 1
const HIGH_PRIORITY = 2
const CRITICAL_PRIORITY = 3

const LOW_PRIORITY_LABEL = 'low'
const MEDIUM_PRIORITY_LABEL = 'medium'
const HIGH_PRIORITY_LABEL = 'high'
const CRITICAL_PRIORITY_LABEL = 'critical'

const PRIORITIES = {
  [LOW_PRIORITY_LABEL]: 'BAIXA',
  [MEDIUM_PRIORITY_LABEL]: 'MÉDIA',
  [HIGH_PRIORITY_LABEL]: 'ALTA',
  [CRITICAL_PRIORITY_LABEL]: 'CRÍTICA',
}

const PRIORITY_OPTIONS = [
  { id: 0, name: 'Baixa', value: 'low' },
  { id: 1, name: 'Média', value: 'medium' },
  { id: 2, name: 'Alta', value: 'high' },
  { id: 3, name: 'Crítica', value: 'critical' },
]

const GREATER_OR_EQUAL_THAN_GOAL_OPERATOR = 0
const LESS_OR_EQUAL_THAN_GOAL_OPERATOR = 1
const EQUAL_TO_GOAL_OPERATOR = 2
const IN_BETWEEN_GOAL_OPERATOR = 3

const GREATER_OR_EQUAL_THAN_GOAL_OPERATOR_ENUM = 'greater_or_equal_than'
const LESS_OR_EQUAL_THAN_GOAL_OPERATOR_ENUM = 'less_or_equal_than'
const EQUAL_TO_GOAL_OPERATOR_ENUM = 'equal_to'
const IN_BETWEEN_GOAL_OPERATOR_ENUM = 'in_between'

const GREATER_OR_EQUAL_THAN_GOAL_OPERATOR_LABEL = 'maior ou igual a'
const LESS_OR_EQUAL_THAN_GOAL_OPERATOR_LABEL = 'menor ou igual a'
const EQUAL_TO_GOAL_OPERATOR_LABEL = 'igual a'
const IN_BETWEEN_GOAL_OPERATOR_LABEL = 'entre'

const GOAL_OPERATORS = {
  [GREATER_OR_EQUAL_THAN_GOAL_OPERATOR]: 'MAIOR OU IGUAL A',
  [LESS_OR_EQUAL_THAN_GOAL_OPERATOR]: 'MENOR OU IGUAL A',
  [EQUAL_TO_GOAL_OPERATOR]: 'IGUAL A',
  [IN_BETWEEN_GOAL_OPERATOR]: 'ENTRE',
}

const GOAL_OPERATOR_OPTIONS = [
  {
    id: 0,
    name: 'Maior ou igual a',
    value: 'greater_or_equal_than',
  },
  {
    id: 1,
    name: 'Menor ou igual a',
    value: 'less_or_equal_than',
  },
  { id: 2, name: 'Igual a', value: 'equal_to' },
  { id: 3, name: 'Entre', value: 'in_between' },
]

const PERCENTAGE_MEASUREMENT_UNIT = 0
const QUANTITY_MEASUREMENT_UNIT = 1
const DAYS_MEASUREMENT_UNIT = 2
const HOURS_MEASUREMENT_UNIT = 3
const MONEY_MEASUREMENT_UNIT = 4
const OTHER_MEASUREMENT_UNIT = 5

const PERCENTAGE_MEASUREMENT_UNIT_LABEL = 'porcentagem'
const QUANTITY_MEASUREMENT_UNIT_LABEL = 'quantidade'
const DAYS_MEASUREMENT_UNIT_LABEL = 'dias'
const HOURS_MEASUREMENT_UNIT_LABEL = 'horas'
const MONEY_MEASUREMENT_UNIT_LABEL = 'valor monetário'
const OTHER_MEASUREMENT_UNIT_LABEL = 'outro'

const MEASUREMENT_UNITS = {
  [PERCENTAGE_MEASUREMENT_UNIT]: 'PORCENTAGEM',
  [QUANTITY_MEASUREMENT_UNIT]: 'QUANTIDADE',
  [DAYS_MEASUREMENT_UNIT]: 'DIAS',
  [HOURS_MEASUREMENT_UNIT]: 'HORAS',
  [MONEY_MEASUREMENT_UNIT]: 'VALOR MONETÁRIO',
  [OTHER_MEASUREMENT_UNIT]: 'OUTRO',
}

const MEASUREMENT_UNIT_OPTIONS = [
  { id: 0, name: 'Porcentagem', value: 'percentage' },
  { id: 1, name: 'Quantidade', value: 'quantity' },
  { id: 2, name: 'Dias', value: 'days' },
  { id: 3, name: 'Horas', value: 'hours' },
  { id: 4, name: 'Valor monetário', value: 'money' },
  { id: 5, name: 'Outro', value: 'other' },
]

const PENDING_STATUS = 0
const OVERDUE_STATUS = 1
const FAILED_STATUS = 2
const ACHIEVED_STATUS = 3

const PENDING_STATUS_LABEL = 'pending'
const OVERDUE_STATUS_LABEL = 'overdue'
const FAILED_STATUS_LABEL = 'failed'
const ACHIEVED_STATUS_LABEL = 'achieved'

const STATUSES = {
  [PENDING_STATUS_LABEL]: 'PENDENTE',
  [OVERDUE_STATUS_LABEL]: 'ATRASADO',
  [FAILED_STATUS_LABEL]: 'NÃO ATINGIDO',
  [ACHIEVED_STATUS_LABEL]: 'ATINGIDO',
}

const STATUS_OPTIONS = [
  { id: 0, name: 'Pendente', value: 'pending' },
  { id: 1, name: 'Atrasado', value: 'overdue' },
  { id: 2, name: 'Não Atingido', value: 'failed' },
  { id: 3, name: 'Atingido', value: 'achieved' },
]

const MONTHLY_PERIODICITY = 0
const BIMONTHLY_PERIODICITY = 1
const QUARTERLY_PERIODICITY = 2
const SEMIANNUALLY_PERIODICITY = 3
const YEARLY_PERIODICITY = 4
const BIYEARLY_PERIODICITY = 5

const MONTHLY_PERIODICITY_LABEL = 'monthly'
const BIMONTHLY_PERIODICITY_LABEL = 'bimonthly'
const QUARTERLY_PERIODICITY_LABEL = 'quarterly'
const SEMIANNUALLY_PERIODICITY_LABEL = 'semiannually'
const YEARLY_PERIODICITY_LABEL = 'yearly'
const BIYEARLY_PERIODICITY_LABEL = 'biyearly'

const PERIODICITIES = {
  [MONTHLY_PERIODICITY_LABEL]: 'MENSAL',
  [BIMONTHLY_PERIODICITY_LABEL]: 'BIMESTRAL',
  [QUARTERLY_PERIODICITY_LABEL]: 'TRIMESTRAL',
  [SEMIANNUALLY_PERIODICITY_LABEL]: 'SEMESTRAL',
  [YEARLY_PERIODICITY_LABEL]: 'ANUAL',
  [BIYEARLY_PERIODICITY_LABEL]: 'BIANUAL',
}

const PERIODICITY_OPTIONS = [
  { id: 0, name: 'Mensal', value: 'monthly' },
  { id: 1, name: 'Bimestral', value: 'bimonthly' },
  { id: 2, name: 'Trimestral', value: 'quarterly' },
  { id: 3, name: 'Semestral', value: 'semiannually' },
  { id: 4, name: 'Anual', value: 'yearly' },
  { id: 5, name: 'Bianual', value: 'biyearly' },
]

export default {
  ACHIEVED_STATUS_LABEL,
  ACHIEVED_STATUS,
  BIMONTHLY_PERIODICITY_LABEL,
  BIMONTHLY_PERIODICITY,
  BIYEARLY_PERIODICITY_LABEL,
  BIYEARLY_PERIODICITY,
  CRITICAL_PRIORITY_LABEL,
  CRITICAL_PRIORITY,
  DAYS_MEASUREMENT_UNIT_LABEL,
  DAYS_MEASUREMENT_UNIT,
  EQUAL_TO_GOAL_OPERATOR_ENUM,
  EQUAL_TO_GOAL_OPERATOR_LABEL,
  EQUAL_TO_GOAL_OPERATOR,
  FAILED_STATUS_LABEL,
  FAILED_STATUS,
  GOAL_OPERATOR_OPTIONS,
  GOAL_OPERATORS,
  GREATER_OR_EQUAL_THAN_GOAL_OPERATOR_ENUM,
  GREATER_OR_EQUAL_THAN_GOAL_OPERATOR_LABEL,
  GREATER_OR_EQUAL_THAN_GOAL_OPERATOR,
  HIGH_PRIORITY_LABEL,
  HIGH_PRIORITY,
  HOURS_MEASUREMENT_UNIT_LABEL,
  HOURS_MEASUREMENT_UNIT,
  IN_BETWEEN_GOAL_OPERATOR_ENUM,
  IN_BETWEEN_GOAL_OPERATOR_LABEL,
  IN_BETWEEN_GOAL_OPERATOR,
  LESS_OR_EQUAL_THAN_GOAL_OPERATOR_ENUM,
  LESS_OR_EQUAL_THAN_GOAL_OPERATOR_LABEL,
  LESS_OR_EQUAL_THAN_GOAL_OPERATOR,
  LOW_PRIORITY_LABEL,
  LOW_PRIORITY,
  MEASUREMENT_UNIT_OPTIONS,
  MEASUREMENT_UNITS,
  MEDIUM_PRIORITY_LABEL,
  MEDIUM_PRIORITY,
  MONEY_MEASUREMENT_UNIT_LABEL,
  MONEY_MEASUREMENT_UNIT,
  MONTHLY_PERIODICITY_LABEL,
  MONTHLY_PERIODICITY,
  OTHER_MEASUREMENT_UNIT_LABEL,
  OTHER_MEASUREMENT_UNIT,
  OVERDUE_STATUS_LABEL,
  OVERDUE_STATUS,
  PENDING_STATUS_LABEL,
  PENDING_STATUS,
  PERCENTAGE_MEASUREMENT_UNIT_LABEL,
  PERCENTAGE_MEASUREMENT_UNIT,
  PERIODICITIES,
  PERIODICITY_OPTIONS,
  PRIORITIES,
  PRIORITY_OPTIONS,
  QUANTITY_MEASUREMENT_UNIT_LABEL,
  QUANTITY_MEASUREMENT_UNIT,
  QUARTERLY_PERIODICITY_LABEL,
  QUARTERLY_PERIODICITY,
  SEMIANNUALLY_PERIODICITY_LABEL,
  SEMIANNUALLY_PERIODICITY,
  STATUSES,
  STATUS_OPTIONS,
  YEARLY_PERIODICITY_LABEL,
  YEARLY_PERIODICITY,
}
